module.exports = __webpack_public_path__ + "static/media/sorry-no-money-results-v2.c2a03818.png";